<input type="file" #acsFileInputComponentElement hidden accept="{{fileTypes}}" [multiple]="allowMultiple">
<button mat-button (click)="standInClick()">
  <mat-icon *ngIf="iconPosition === 'before'" class="fa-paperclip"></mat-icon>
  {{buttonText}} 
  <mat-icon *ngIf="iconPosition === 'after'" class="fa-paperclip"></mat-icon>
</button>
